import React from 'react';
import { Route } from "react-router-dom";
import AppLogout from '../../common/isLogout';
import { PrivateRoute } from '../../common/PrivateRoutes';
import AddContent from '../../Pages/AddContent';
import TutorialTroublesooting from '../../Pages/TutorialTroublesooting';
import ModuleList from '../../Pages/ModuleList';
import AddModule from '../../Pages/AddModule';
import DashboardLayout from '../../Layouts/DashboardLayouts';

const TrainingRoutes = () => (
  <>
    {/* Training feature */}
    <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
      <Route exact path="/training/tutorialtroubleshooting" element={<AppLogout><PrivateRoute><TutorialTroublesooting /></PrivateRoute></AppLogout>} />
      <Route exact path="/training/addcontent" element={<AppLogout><PrivateRoute><AddContent /></PrivateRoute></AppLogout>} />
      <Route exact path="/training/modules/list" element={<AppLogout><PrivateRoute><ModuleList /></PrivateRoute></AppLogout>} />
      <Route exact path="/training/addmodules" element={<AppLogout><PrivateRoute><AddModule /></PrivateRoute></AppLogout>} />
      <Route exact path="/training/editmodules/:id" element={<AppLogout><PrivateRoute><AddModule /></PrivateRoute></AppLogout>} />
    </Route>
  </>
);

export default TrainingRoutes;